import React, { useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import car from "../../assets/images/palettenTransport-why-bg.jpg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const TransCiroxSpeditionsversand = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section className="service-section bg-light">
      <Container className="px-4 px-md-5 py-5">
        {/* العنوان الرئيسي فوق النص والصورة */}
        <Row className="mb-5 text-center" data-aos="fade-down">
          <Col>
            <h2 className="fw-bold text-orange">
              {t("TransCiroXSpeditionsversand.title")}
            </h2>
          </Col>
        </Row>

        {/* النص والصورة */}
        <Row className="align-items-center gy-4">
          {/* الصورة */}
          <Col md={6} data-aos="fade-right" className="text-center">
            <img
              src={car}
              alt="Spedition Transport"
              className="img-fluid rounded shadow img-car"
            />
          </Col>
          {/* النص */}
          <Col md={6} data-aos="fade-left">
            <h5 className="text-orange fw-semibold mb-3">
              {t("TransCiroXSpeditionsversand.subtitle")}
            </h5>
            <p className="text-muted fs-6">
              {t("TransCiroXSpeditionsversand.description_1")}
            </p>
            <p className="text-muted fs-6">
              {t("TransCiroXSpeditionsversand.description_2")}
            </p>

            {/* الزر */}
            {/* <Button
              variant="warning"
              size="lg"
              className="bg-orange-500 text-white mt-3"
              onClick={() => navigate("/register/client")}
            >
              {t("TransCiroXSpeditionsversand.button")}
            </Button> */}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default TransCiroxSpeditionsversand;
